import { render, staticRenderFns } from "./NbCustom.vue?vue&type=template&id=187a2dc0"
import script from "./NbCustom.vue?vue&type=script&lang=js"
export * from "./NbCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports